export const StudentGroupConstant = {
  STUDENT_GROUP_OPEN: "STUDENT_GROUP_OPEN",
  UPDATE_STUDENT_GROUP: "UPDATE_STUDENT_GROUP",
  UPDATE_GROUP_DATA: "UPDATE_GROUP_DATA",
  SET_GROUP_DATA: "SET_GROUP_DATA",
  DELTE_GROUP_DATA:"DELTE_GROUP_DATA",
  SET_CLASSID_BY_DATA: "SET_CLASSID_BY_DATA"
};
